import React from 'react';
import { Link } from '@common/components';
import { Result, Button } from 'antd';
import { imagePath } from '@common/services/images-service';

export function FourZeroFour() {
  return (
    <>
      <Result
        className="FourZeroFour"
        icon={
          <img
            src={imagePath('./works-logo-dashed.png')}
            alt="Trusted Works Logo"
            width="32px"
          />
        }
        title="404 - Page not found"
        subTitle="Sorry, the page you're looking for doesn't exist or you're trying to access with a different account."
        extra={
          <Link to="/works">
            <Button type="primary">Back Home</Button>
          </Link>
        }
      />
      <style jsx global>{`
        .FourZeroFour img {
          width: 175px;
        }
      `}</style>
    </>
  );
}
